import axios from 'axios';
import { getConfig } from '../../config';

export const instance = axios.create({
  baseURL: getConfig().apiUrl,
  timeout: 10000,
});
